import { apiClient } from "./client";

let inFlight = null;

/**
 * Public settings (GET /api/app/config), among them the prices the server
 * charges: { prices: { verificationFeePaise, institutionSubscriptionPaise,
 * organisationSubscriptionPaise, professionalMembershipPaise } }. Callers
 * asking at the same moment share one
 * request; a later call asks again, so a price is never stale.
 */
export function fetchAppConfig() {
  inFlight ??= apiClient
    .get("/app/config")
    .then((res) => res.data)
    .finally(() => {
      inFlight = null;
    });
  return inFlight;
}

const PRICE_KEYS = {
  VERIFICATION_FEE: "verificationFeePaise",
  INSTITUTION_SUBSCRIPTION: "institutionSubscriptionPaise",
  ORGANISATION_SUBSCRIPTION: "organisationSubscriptionPaise",
  PROFESSIONAL_MEMBERSHIP: "professionalMembershipPaise",
};

/** The price of a payment type from the settings, or null when missing. */
export function priceOf(config, type) {
  const price = config?.prices?.[PRICE_KEYS[type]];
  return Number.isInteger(price) && price > 0 ? price : null;
}
